module.exports = __webpack_public_path__ + "staticesp/media/holos.674b8047.mp4";